/**
 * This function returns product from vow collection json
 * @params
 * products = json of product which has to be iterate i.e collection
 * productId = The id of the product which has to be get
 **/
function getProductInfoFromCollection(products, productId) {
  if (products && productId) {
    var selectedProduct = {}
    products.map(function (products, i) {
      if (parseInt(products.id) == parseInt(productId)) {
        selectedProduct = products
      }
    })
    return selectedProduct
  } else {
    return null
  }
}

function VOW_variant_select_images(productId, products, selectedVariantId) {
  if (products) {
    var images = []
    if (products !== '') { images = products.media; }
    vowloadingImages(images, productId, selectedVariantId)
  }
}

function vowloadingImages(images, productId, selectedVariantId) {
  var carouselImage = false
  if ($('.carousel.MobSlider' + productId).length) { carouselImage = true }
  var countImage = $(".AspectRatio").find(".img" + productId).length
  if (images && images.length) {
    var variantImage = $.map(images, vari => {
      if (vari.alt && vari.alt != null && vari.alt != '') {
        if (vari.alt.indexOf(String(selectedVariantId)) !== -1) { return vari }
      }
    })
    if (variantImage && variantImage.length) {
      var newArray = variantImage
      $.map(newArray, (v, i) => {
        if (i < countImage) {
          var selected = i === 0 ? 'is-selected' : ''
          $(".AspectRatio").find(".img" + productId + ':eq(' + i + ')').addClass(`${selected}`).attr('data-src', v.src).attr('src', v.src).attr('data-image-id', v.alt).attr('alt', v.alt)
        }
        if (carouselImage && i < countImage) {
          $(".carousel.MobSlider" + productId).find('.flickity-slider').find('img:eq(' + i + ')').attr('src', v.src)
        }
      })
    } else {
      showVowProductImages(productId, countImage, carouselImage)
    }
  } else {
    showVowProductImages(productId, countImage, carouselImage)
  }
  changeSliderArrows();
}

function showVowProductImages(productId, countImage, carouselImage) {
  var pro = $.map(products, v => { if (String(v.id) === String(productId)) { return v; } })
  if (pro && pro[0] && pro[0].length) {
    $.map(pro[0].media, (img, i) => {
      if (i < countImage) {
        var selected = i === 0 ? 'is-selected' : ''
        $(".AspectRatio").find(".img" + productId + ':eq(' + i + ')').addClass(`${selected}`).attr('data-src', img.src).attr('src', img.src).attr('data-image-id', img.id).attr('alt', img.alt)
      }
      if (carouselImage && i < countImage) $(".carousel.MobSlider" + productId).find('.flickity-slider').find('img:eq(' + i + ')').attr('src', img.src)
    })
  }
}

function setDefaultVariantsInGrid() {
  $(".Grid__Cell").each(function (index) {
    let diamondText = $(this).find(".ProductItem__Title a").clone().find("span").remove().end().text().trim();
    let diamond = null;
    let metal = null;
    const diamondFound = diamondMetalMappings.find(item => item.name === diamondText);
    if (diamondFound) {
      diamond = getDiamondOtherNames(diamondFound.diamond);
      metal = getMetalOtherNames(diamondFound.metal);
    } else {
      variantIdData = diamondText;
    }
    if (diamond && diamond.length > 0) {
      for (var i = 0; i < diamond.length; i++) {
        if ($('li[itemid="' + diamond[i].toLowerCase() + '"]>a').length > 0)
          $(this).find('li[itemid="' + diamond[i].toLowerCase() + '"]>a').trigger("click")
      }
    }
    if (metal && metal.length > 0) {
      for (var i = 0; i < metal.length; i++) {
        if ($('li[itemid="' + metal[i] + '"]>a').length > 0)
          $(this).find('li[itemid="' + metal[i] + '"]>a').trigger("click")
      }
    }
  })
}

function changeImage(clickedItem) {
  var diamondShape = $(clickedItem).attr("data-value")
  var productId = $(clickedItem).attr("data-productId")
  var isSelectWithDiamondFirst = getParameterByName('startwithsetting');
  var metalName = $(".metalShapes" + productId).find('li.active a').attr('data-title');
  $(".MobSlider" + productId).flickity('select', 0);
  $(".diamondshape" + productId).find('.diamondShapes').parent().removeClass('active')
  $(".diamondshape" + productId).find("span.diamond-shape-name").text("");
  $(clickedItem).parent().addClass('active')
  var productInfo = getProductInfoFromCollection(products, productId)
  var variantInfo = getVowProductVariantInfo(productInfo, diamondShape, metalName, "Original Design")
  var decodedString = decodeURIComponent(variantInfo.option2);
  var selectedMetal = decodedString.replace(/\s+/g, '');
  if (variantInfo && variantInfo.id) {
    if (isSelectWithDiamondFirst && isSelectWithDiamondFirst === "true") {
      var detailPageUrl = `/products/${productInfo.handle}?variant=${variantInfo.id}&diamondType=${variantInfo.option1}&metal=${selectedMetal}&startwithsetting=true`
    } else {
      var detailPageUrl = `/products/${productInfo.handle}?variant=${variantInfo.id}&diamondType=${variantInfo.option1}&metal=${selectedMetal}`
    }
    $(".product_redirecturl" + productId).attr('href', detailPageUrl);
    $("#selectedProduct_" + productId).attr('href', detailPageUrl);
    VOW_variant_select_images(productId, productInfo, variantInfo.id)
  } else {
    console.log("Error in finding variant info")
  }
}

function changeShapesImage(clickedItem) {
  var metalName = $(clickedItem).attr("data-title")
  var productId = $(clickedItem).attr("data-productId")
  var isSelectWithDiamondFirst = getParameterByName('startwithsetting');
  var diamondShape = $(".diamondshape" + productId).find('li.active a').attr("data-title")
  $(".MobSlider" + productId).flickity('select', 0);
  $(".metalShapes" + productId).find('.metalShapes').parent().removeClass('active')
  $(clickedItem).parent().addClass('active')
  var productInfo = getProductInfoFromCollection(products, productId)
  var variantInfo = getVowProductVariantInfo(productInfo, diamondShape, metalName, js_original_design_str)
  var decodedString = decodeURIComponent(variantInfo.option2);
  var selectedMetal = decodedString.replace(/\s+/g, '');
  if (variantInfo && variantInfo.id) {
    if (isSelectWithDiamondFirst && isSelectWithDiamondFirst === "true") {
      var detailPageUrl = `/products/${productInfo.handle}?variant=${variantInfo.id}&diamondType=${variantInfo.option1}&metal=${selectedMetal}&startwithsetting=true`
    } else {
      var detailPageUrl = `/products/${productInfo.handle}?variant=${variantInfo.id}&diamondType=${variantInfo.option1}&metal=${selectedMetal}`
    }
    $(".product_redirecturl" + productId).attr('href', detailPageUrl);
    $("#selectedProduct_" + productId).attr('href', detailPageUrl);
    VOW_variant_select_images(productId, productInfo, variantInfo.id)
  } else {
    console.log("Error in finding variant info")
  }
}

/* ========= SHAPE LOOKUP MAPS :: Exact mappings — no partial string matching anywhere.========= */
// Raw filter key → exact itemid on product card li[itemid]
var DIAMOND_ITEMID_MAP = {
  'Round':                 'round',
  'Oval':                  'oval',
  'Cushion':               'cushion',
  'Emerald':               'emerald',
  'Radiant':               'radiant',
  'Pear':                  'pear',
  'European':              'antique-style-round',
  'OldMine':               'antique-style-cushion',
  'Marquise':              'marquise',
  'Antique-Style Round':   'antique-style-round',
  'Antique-Style Cushion': 'antique-style-cushion',
};

// Raw filter key → exact variant option1 value(s) in Shopify
var DIAMOND_OPTION1_MAP = {
  'Round':                 ['Round'],
  'Oval':                  ['Oval'],
  'Cushion':               ['Cushion'],
  'Emerald':               ['Emerald'],
  'Radiant':               ['Radiant'],
  'Pear':                  ['Pear'],
  'European':              ['Antique-Style Round'],
  'OldMine':               ['Antique-Style Cushion'],
  'Marquise':              ['Marquise'],
  'Antique-Style Round':   ['Antique-Style Round'],
  'Antique-Style Cushion': ['Antique-Style Cushion'],
};

function getDiamondOption1Values(rawKey) {
  if (DIAMOND_OPTION1_MAP[rawKey]) return DIAMOND_OPTION1_MAP[rawKey];
  var expanded = getDiamondOtherNames(rawKey);
  return (expanded && expanded.length) ? expanded : [rawKey];
}

function getDiamondItemId(rawKey) {
  return DIAMOND_ITEMID_MAP[rawKey] || rawKey.toLowerCase();
}

/**
 * Given a product's variant list and a raw filter key,
 * returns true if the product actually has a variant for that shape.
 * Used to decide which shape image to show on the card.
 */
function productHasShape(productVariants, rawKey) {
  var option1Values = getDiamondOption1Values(rawKey);
  return productVariants.some(function (vari) {
    return option1Values.some(function (opt1) {
      if (opt1 === 'Emerald') {
        return vari.option1 === 'Emerald' || vari.option1.startsWith('Emerald (');
      }
      return vari.option1 === opt1;
    });
  });
}

/* ========= SELECTION ORDER TRACKERS ========= 
   These arrays track the ORDER items were selected, most-recent LAST.
   The last item in the array = the most recently selected = shown on product cards.
   When an item is deselected, it is removed from the array.
*/
var _diamondSelectionOrder = [];
var _metalSelectionOrder   = [];

/* ========= CHECKBOX SYNC ========= */
function syncCheckbox(liEl, isActive) {
  $(liEl).find('input[type="checkbox"]').prop('checked', isActive);
}

function syncAllCheckboxes() {
  $('.dropdown-menu li').each(function () {
    var value = $(this).data('value');
    var isActive = $('ul.diamond-shape-list-filters #filterdiamond' + value).parent().hasClass('active');
    syncCheckbox(this, isActive);
  });
  $('.metal-dropdown-menu li').each(function () {
    var target = $(this).data('target');
    if (target) {
      var isActive = $('ul.metal-list-filters #' + target).parent().hasClass('active');
      syncCheckbox(this, isActive);
    }
  });
}

/* ========= URL HELPER ========= */
function updateFilterUrl(dp, mp) {
  var urlObj = new URL(window.location.href);
  var params = urlObj.searchParams;
  params.delete('zCountry');
  if (dp && dp.length > 0) { params.set('dp', dp); } else { params.delete('dp'); }
  if (mp && mp.length > 0) { params.set('mp', mp); } else { params.delete('mp'); }
  var paramStr = params.toString();
  history.pushState({}, '', urlObj.pathname + (paramStr ? '?' + paramStr : ''));
}

/* ========= CORE: filterProducts  (MULTI-SELECT) ========= */
var historyState = {};

function filterProducts(name, type) {
  var dp = '';
  var mp = '';

  /* ── DIAMOND shape toggle (MULTI) ── */
  if (type === 'diamond') {
    // Scope to diamond-shape-list-filters to avoid any ID collisions
    var $anchor = $('ul.diamond-shape-list-filters #filterdiamond' + name);
    var $li = $anchor.parent();
    var wasActive = $li.hasClass('active');
    $li.toggleClass('active');

    // Update selection order array
    if (wasActive) {
      // Deselected — remove from order array
      _diamondSelectionOrder = _diamondSelectionOrder.filter(function(k) { return k !== name; });
    } else {
      // Selected — push to end (most recent)
      _diamondSelectionOrder = _diamondSelectionOrder.filter(function(k) { return k !== name; });
      _diamondSelectionOrder.push(name);
    }

    $('.dropdown-menu li[data-value="' + name + '"]').each(function () {
      syncCheckbox(this, !wasActive);
    });

    // Update label text
    var activeNames = [];
    $(".diamond-shape-list-filters li.active > a").each(function () {
      activeNames.push($(this).next("span").text());
    });
    $(".clicked-diamond-shape-name").text(activeNames.length ? ' - ' + activeNames.join(', ') : '');
    $('.selected-value').text(activeNames.length ? activeNames.join(', ') : 'Select');
  }

  /* ── METAL colour toggle (MULTI) ── */
  else if (type === 'shape') {
    var metalCaratName = '';
    if (name === 'Yellow Gold' || name === 'YellowGold') {
      metalCaratName = '14K Yellow';
    } else if (name === 'Rose Gold' || name === 'RoseGold') {
      metalCaratName = '14K Rose';
    } else {
      metalCaratName = name;
    }

    // Scope to metal-list-filters to avoid the duplicate hidden anchor
    var $anchor = $('ul.metal-list-filters #filtershape' + name);
    var $li = $anchor.parent();
    var wasActive = $li.hasClass('active');

    $li.toggleClass('active');
    $anchor.toggleClass('active');
    $anchor.next('span').text(wasActive ? '' : metalCaratName);

    // Update metal selection order array
    if (wasActive) {
      _metalSelectionOrder = _metalSelectionOrder.filter(function(k) { return k !== name; });
    } else {
      _metalSelectionOrder = _metalSelectionOrder.filter(function(k) { return k !== name; });
      _metalSelectionOrder.push(name);
    }

    var targetId = 'filtershape' + name;
    $('.metal-dropdown-menu li[data-target="' + targetId + '"]').each(function () {
      syncCheckbox(this, !wasActive);
    });

    // Update label
    var activeMetals = [];
    $("ul.metal-list-filters li.active > a").each(function () {
      var n = $(this).attr('data-title');
      if (n) activeMetals.push(n);
    });
    $(".clicked-metal-color").text(activeMetals.length ? ' - ' + activeMetals.join(', ') : '');
    $('.metal-selected').text(activeMetals.length ? activeMetals.join(', ') : 'Select');
  }

  // Build dp using SELECTION ORDER (most recently selected = last = first to try for images)
  // Keep URL order = selection order so URL reflects user intent
  var activeDiamondSet = {};
  $(".diamond-shape-list-filters li.active > a").each(function () {
    activeDiamondSet[$(this).attr('id').replace('filterdiamond', '')] = true;
  });
  // Build dp in selection order, only including currently active items
  var dpOrdered = _diamondSelectionOrder.filter(function(k) { return activeDiamondSet[k]; });
  dp = dpOrdered.join(',');

  var activeMetalSet = {};
  $("ul.metal-list-filters li.active > a").each(function () {
    var val = $(this).attr('val');
    if (val) activeMetalSet[val] = true;
  });
  var mpOrdered = _metalSelectionOrder.filter(function(k) { return activeMetalSet[k]; });
  mp = mpOrdered.join(',');

  /* ── URL update — uses URLSearchParams (no more fragile string replace) ── */
  updateFilterUrl(dp, mp);

  setTimeout(function () {
    const hasDiamond = $('.diamond-shape-list-filters li.active').length > 0;
    const hasMetal = $('ul.metal-list-filters li.active').length > 0;
    if (hasDiamond || hasMetal) {
      $(".available__filter-reset").removeClass("hide");
      searchProducts();
    } else {
      searchProducts('reset');
      setDefaultVariantsInGrid();
    }
    handleEmptyFilterState();
  }, 5);
}

/* ========= CORE: searchProducts  (MULTI-SELECT) ========= */
searchProducts = function (action) {
  var srdp = getQueryParams('dp') ? getQueryParams('dp') : '';
  var srmp = getQueryParams('mp') ? getQueryParams('mp') : 'YellowGold';

  // URL preserves selection order — last item = most recently selected
  var dpList = srdp ? srdp.split(',').map(function (s) { return s.trim(); }) : [];
  var mpList = srmp ? srmp.split(',').map(function (s) { return s.trim(); }) : [];

  var searchProductList = products;

  if (action == null) {
    var hasDiamond = dpList.length > 0;
    var hasMetal   = mpList.length > 0;

    if (hasDiamond || hasMetal) {
      searchProductList = $.map(searchProductList, function (v) {
        var status = false;
        $.map(v.variants, function (vari) {
          if (status) return;

          // Exact diamond match per selected shape
          var diamondMatch = !hasDiamond || dpList.some(function (rawKey) {
            return getDiamondOption1Values(rawKey).some(function (opt1) {
              if (opt1 === 'Emerald') {
                return vari.option1 === 'Emerald' || vari.option1.startsWith('Emerald (');
              }
              return vari.option1 === opt1;
            });
          });

          // Metal match
          var metalMatch = !hasMetal;
          if (!metalMatch) {
            metalMatch = mpList.some(function (rawMp) {
              var expanded = getMetalOtherNames(rawMp);
              if (!expanded || !expanded.length) return false;
              return expanded.some(function (expandedName) {
                return vari.option2 && vari.option2.indexOf(expandedName) !== -1;
              });
            });
          }
          if (diamondMatch && metalMatch) status = true;
        });
        if (status) return v;
      });
    }
  }

  // Hide everything, then reveal matches
  $(".ProductList--grid > .Grid__Cell").addClass('productHidden');
  var $noData = $("<h1 id='noDiamondAvaialble'>No Diamond available for selected filter</h1>");
  $(".ProductList--grid").prepend($noData);

  $.map(searchProductList, function (vari) {
    var pid = ".product_grid" + vari.id;

    // Shape image: iterate in REVERSE (last = most recently selected = highest priority)
    if (dpList && dpList.length) {
      var shapeTriggered = false;
      for (var i = dpList.length - 1; i >= 0; i--) {
        var rawKey = dpList[i];
        if (productHasShape(vari.variants, rawKey)) {
          if (rawKey === 'Emerald') {
            $(pid).find('li[itemid^="emerald"] > a').first().trigger("click");
          } else if(rawKey === 'European') {
            $(pid).find('li[itemid^="antique-style round"] > a').first().trigger("click");
          } else if(rawKey === 'OldMine') {
            $(pid).find('li[itemid^="antique-style cushion"] > a').first().trigger("click");
          } else {
            var itemId = getDiamondItemId(rawKey);
            $(pid).find('li[itemid="' + itemId + '"] > a').trigger("click");
          }
          shapeTriggered = true;
          break;
        }
      }
      // Fallback: no selected shape matched — reset to product's first shape
      if (!shapeTriggered) {
        $(pid).find('li[itemid] > a').first().trigger("click");
      }
    }

    // Metal image: iterate in REVERSE (last = most recently selected = highest priority)
    // Try ALL expanded aliases per metal until one matches this product card's data-title.
    if (mpList && getQueryParams('mp')) {
      var metalTriggered = false;
      for (var j = mpList.length - 1; j >= 0; j--) {
        if (metalTriggered) break;
        var expanded = getMetalOtherNames(mpList[j]);
        if (expanded && expanded.length) {
          for (var k = 0; k < expanded.length; k++) {
            var $metalAnchor = $(pid).find('a[data-title="' + expanded[k] + '"]');
            if ($metalAnchor.length) {
              $metalAnchor.trigger("click");
              metalTriggered = true;
              break;
            }
          }
        }
      }
    }

    if (!(vari.tags.includes("hide-marquise-diamond") && dpList.indexOf("Marquise") !== -1)) {
      $(pid).removeClass("productHidden");
    }
    $('#noDiamondAvaialble').remove();
  });
};

/* ========= RESET ========= */
function resetCollectionPageFilter() {
  var uri = window.location.toString();
  if (uri.indexOf("?") > 0) {
    var isSelectWithDiamondFirst = getParameterByName('startwithsetting');
    if (isSelectWithDiamondFirst === 'true') {
      var clean_uri = uri.substring(0, uri.indexOf("?")) + '?startwithsetting=true';
      window.history.replaceState({}, document.title, clean_uri);
    } else {
      window.history.replaceState({}, document.title, uri.substring(0, uri.indexOf("?")));
    }

    _diamondSelectionOrder = [];
    _metalSelectionOrder   = [];

    $(".dropdown-title").find(".selected-value").text("Select");
    $(".metal-dropdown-btn").find(".metal-selected").text("Select");
    $(".clicked-diamond-shape-name, .clicked-metal-color").text('');

    $('ul.diamond-shape-list-filters > li').removeClass('active');
    $('ul.metal-list-filters > li, ul.metal-list-filters > li > a').removeClass('active');
    $('ul.metal-list-filters > li > span').text('');

    $(".available__filter-reset").addClass("hide");

    syncAllCheckboxes();

    var filterStatusMessage = '#filter-status-message';
    $(filterStatusMessage).text('clear all filter successfully').focus();
    $('.reset__button').blur();
    setTimeout(function () { $(filterStatusMessage).text(''); }, 100);

    setTimeout(function () {
      searchProducts('reset');
      setDefaultVariantsInGrid();
      handleEmptyFilterState();
    }, 100);
  }
}

/* ========= DOCUMENT READY FUNCTION CALL ========= */
$(document).ready(function () {
  // Diamond shape dropdown — stopPropagation keeps dropdown open for multi-select
  $('.dropdown-menu li').off('click').on('click', function (e) {
    e.stopPropagation();
    var value = $(this).data('value');
    filterProducts(value, 'diamond');
  });

  // Metal colour dropdown — onclick removed from HTML so no double-firing
  $('.metal-dropdown-menu li').off('click').on('click', function (e) {
    e.stopPropagation();
    var target = $(this).data('target');
    if (!target) return;
    var name = target.replace('filtershape', '');
    filterProducts(name, 'shape');
  });

  // Color legend — open/close metal dropdown
  $(".diamond-color-settings").on('click', function () {
    $(".diamond-shapes").removeClass("active");
    $(".diamond__shape").find(".dropdown.metal-dropdown").removeClass("active");
    $(this).toggleClass("active");
    $('.metal-dropdown.diamond-color-setting-dropdown').toggleClass('active');
  });

  // Shape legend — open/close diamond dropdown
  $(".diamond-shapes").on('click', function () {
    $(".diamond-color-settings").removeClass("active");
    $(".diamond-color-setting-dropdown").removeClass("active");
    $(this).toggleClass("active");
    $(this).closest('.diamond__shape').find('.dropdown.metal-dropdown').toggleClass('active');
  });

  // Close all dropdowns on scroll
  $(window).on("scroll", function () {
    $(".diamond-shapes").removeClass("active");
    $(".diamond__shape").find(".dropdown.metal-dropdown").removeClass("active");
    $(".diamond-color-settings").removeClass("active");
    $(".diamond-color-setting-dropdown").removeClass("active");
  });

  // Close dropdowns when clicking outside
  $(document).on('mousedown', function (e) {
    if (!$(e.target).closest('.diamond__shape').length && !$(e.target).closest('.metal__material').length) {
      $(".diamond-shapes").removeClass("active");
      $(".diamond__shape").find(".dropdown.metal-dropdown").removeClass("active");
      $(".diamond-color-settings").removeClass("active");
      $(".diamond-color-setting-dropdown").removeClass("active");
    }
  });
  
  $('.diamond-shapes, .diamond-color-settings, .dropdown-title').on('mousedown', function (e) {
    e.stopPropagation();
  });

  $('.dropdown-title').on('click', function () {
    $(this).parent().toggleClass('active');
  });

  // Mobile filter toggle
  $('.filter-btn').on('click', function () {
    const $filterBtn = $('.filter-icon-text');
    const isExpanded = $filterBtn.attr('aria-expanded') === 'true';
    $filterBtn.attr('aria-expanded', !isExpanded ? 'true' : 'false');
    $('#mobile-filter').toggleClass('filter-open');
    $('#mobile-filter').next(".available__toggle").toggleClass('filter-open-tg');
    $('.filter-icon').toggleClass('hide');
    $('.close-filter').toggleClass('show');
    $filterBtn.text($filterBtn.text() === 'Filter' ? 'Close Filter' : 'Filter');
  });

  // Availability toggle
  let searchParams = new URLSearchParams(window.location.search);
  let toggleOnOff = searchParams.has('availability');
  if (toggleOnOff) {
    $('.nonhometryno').addClass('hide');
  } else {
    $('.nonhometryno').removeClass('hide');
  }

  var isSelectWithDiamondFirst = getParameterByName('startwithsetting');
  var grabDiamondInfo = getParameterByName('dp');
  var grabMetalInfo   = getParameterByName('mp');

  if (isSelectWithDiamondFirst && isSelectWithDiamondFirst === "true") {
    $('.ProductForm__AddToCart').each(function () {
      var currentHref = $(this).attr('href');
      if (!currentHref.includes('startwithsetting=true')) {
        var updatedHref = currentHref.includes('?')
          ? currentHref + '&startwithsetting=true'
          : currentHref + '?startwithsetting=true';
        $(this).attr('href', updatedHref);
      }
    });
  }

  // Pre-select diamonds from URL on page load (supports comma-separated list)
  if (grabDiamondInfo) {
    grabDiamondInfo.split(',').forEach(function (d) {
      filterProducts(d.trim(), 'diamond');
    });
  }

  // Pre-select metals from URL on page load (supports comma-separated list)
  if (grabMetalInfo) {
    grabMetalInfo.split(',').forEach(function (m) {
      filterProducts(m.trim(), 'shape');
    });
  }

  setDefaultVariantsInGrid();
});

function handleEmptyFilterState() {
  const hasDiamond = $('.diamond-shape-list-filters li.active').length > 0;
  const hasMetal = $('ul.metal-list-filters li.active').length > 0;

  if (!hasDiamond && !hasMetal) {
    // Close dropdowns
    $(".diamond-shapes").removeClass("active");
    $(".diamond__shape .dropdown.metal-dropdown").removeClass("active");
    $(".diamond-color-settings").removeClass("active");
    $(".diamond-color-setting-dropdown").removeClass("active");

    // Hide clear filter CTA
    $(".available__filter-reset").addClass("hide");

    // Reset labels (optional but recommended)
    $('.selected-value').text('Select');
    $('.metal-selected').text('Select');
    $(".clicked-diamond-shape-name, .clicked-metal-color").text('');
  }
}